






























































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { FinancialReportData } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";
import { ApplicationBudget, Feedback } from "@/entities";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import HeaderInfo from '../../ExpansionPanel/FinExpansionPanel.vue';
import NavButtons from '@/components/common/Buttons/NavButtons.vue';
import { Locales } from "@/i18n/locales";
import "@pan-gms/vuetify-jsonschema-form/dist/main.css";
import "vuetify/dist/vuetify.min.css";

const namespace: string = "financialReport";

@Component({
  components: {
    VJsonschemaForm,
    HeaderInfo,
    NavButtons
  }
})
export default class ForecastComponent extends Vue {
  @State(namespace) financialReport!: FinancialReportData;
  @Getter("selectedReport", { namespace }) report: any;
  @Getter("grantInfo", { namespace }) grantInfo: any;
  @Getter("_appUserId", { namespace: "RootApp" } ) _userid!: number
  @State("feedback") feedback!: Feedback;
  @Action("createFeedbackHeader", { namespace: "feedback" }) createFeedbackHeader: any;
  @Action("getFeedbacks", { namespace: "feedback" }) getFeedbacks: any;
  @Action("resolve", { namespace: "feedback" }) resolveFeedback: any;
  @Action("reopen", { namespace: "feedback" }) reopenFeedback: any;
  @Prop() financialReportSections: any;
  @Prop() model: any;
  @Prop() readonly: any;
  @Prop() reportLength: any;
  @Prop() forecastPeriod: string;
  @Prop() schema: any;
  @Prop() formOptions: any;
  @Prop() validations: any;
  @Prop() fileImported: boolean;
  @Prop() typeMismatches: any;
  @Prop() forecastValidations: any;
  @Prop() isDirty: any;
  @Prop() workFlowItems: any;
  @Prop() preValidation: any;
  @Prop() entity: any;
  @Prop() currency: string;
  @Prop() enableButton: any;
  @Prop() applicationBudgetForGrant: any;
  formValid: boolean = false;
  schemaformKey: number = 0;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  showError(err) {
    window.alert(err);
  }

  /** change event */
  showChange(e) {
    this.$emit("input", true);
    // this.isDirty = true;
  }

  /** input event */
  showInput(e) {
    this.$emit("input", true);
    // this.isDirty = true;
  }

  getFeedbackHeader(rowKey) {
    if (this.formOptions && this.formOptions.feedbacks) {
      return this.formOptions.feedbacks.find(x => x.RowKey === rowKey);
    } else {
        return null;
    }
  }
  
  get options(): any {
    return {
      disableAll: this.formOptions.disableAll,
      currency: this.currency || 'EUR',
      transactionId: this.financialReport.selectedReport.FinancialReportId,
      seriesHeader: this.forecastPeriod,
      importValidations: this.validations,
      // validations: this.forecastValidations,
      // typeMismatches: this.typeMismatches,
      //@ts-ignore
      rights: this.$can("manage", "feedback") ? _app.actions.manage : _app.actions.read,
      user: this._userid,
      entity: _app.entities.finReport,
      feedbacks: this.feedback.feedbackHeaders,
      indirectCost: this.applicationBudgetForGrant.indirectCost,
      actions: {
        createHeader:this.createFeedbackHeader,
        list: this.getFeedbacks,
        resolveFeedback: this.resolveFeedback,
        reopenFeedback: this.reopenFeedback
      },
      locale: this.defaultLocale
    };
  }

  get template() {
    if(this.schema && this.schema.properties && this.schema.properties.forecastTemplate) {
      return this.schema.properties.forecastTemplate
    }
  }

  @Watch("model")
  onDataChanged(value: any, oldValue: any) {
    this.schemaformKey += 1;
  }
  // @Watch("typeMismatches", { deep: true })
  // onValidation(value: any) {
  //   console.log('type Mismatches');
  //   console.log(this.validations);
  //   this.schemaformKey += 1;
  // }
}
